* {
  box-sizing: border-box;
}

.footer {
  .page-container-wrapper {
    border-top: 1px solid #ededed;
    line-height: 20px;
    background-color: #f6f6f6;
    color: #717171;

    .page-container {
      padding-top: 48px;
      padding-bottom: 24px;
      max-width: 1290px;
      padding-left: 20px;
      padding-right: 20px;
      margin: 0 auto;

      .footer-links {
        padding-bottom: 60px;

        ul {
          width: 25%;
          float: left;
          list-style: none;
          margin: 0;
          padding: 0;

          li {
            margin-bottom: 12px;
            font-size: 16px;
            font-weight: 500;
             min-height: 20px;

            a {
              display: inline-block;
              color: #717171;
              cursor: pointer;

              &:hover {
                text-decoration: underline;
              }
            }

            a {
              display: inline-block;
              color: #717171;
              font-weight: 500;
              text-decoration: none;
              min-height: 20px;

              &:hover {
                text-decoration: underline;
              }
            }

            span.item-link {
              text-decoration: none;
              cursor: pointer;

              &:hover {
                text-decoration: underline;
              }
            }

            &:first-child {
              font-weight: 600;
              color: #222222;
              margin-bottom: 24px;
            }

            &.footer-logos {
              margin-top: 48px;

              .footer-logo-item {
                margin-bottom: 24px;

                span {
                  display: block;
                  font-size: 14px;
                  font-weight: 500;
                  color: #222222;
                  margin-bottom: 12px;
                }

                img {
                  max-height: 32px;
                }
              }
            }
          }
        }

        &:after {
          content: '';
          display: table;
          clear: both;
        }
      }

      .branding {
        border-top: 1px solid #2222221F;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-top: 24px;
        font-size: 14px;

        .copyright {
          display: flex;
          align-items: center;
          color: #717171;

          strong {
            display: inline-block;
            color: #717171;
            margin-left: 5px;
          }
        }

        .list {
          list-style: none;
          margin: 0;
          padding: 0;

          .list__item {
            margin: 5px 5px 0 0;
            float: left;

            &.facebook a {
              background-image: url(../../assets/icon/var_list--social__item--facebook__link_background-image.svg);
            }

            &.twitter a {
              background-image: url(../../assets/icon/var_list--social__item--twitter__link_background-image.svg);
            }

            &.linkedin a {
              background-image: url(../../assets/icon/var_list--social__item--linkedin__link_background-image.svg);
            }
          }

          a {
            display: block;
            width: 32px;
            height: 32px;
            overflow: hidden;
            text-indent: 100%;
            background-repeat: no-repeat;
            background-position: 50% 50%;
            opacity: 0.5;

            &:hover {
              opacity: 1;
            }
          }
        }
      }
    }
  }
}


@media (max-width: 995px) {
  .footer {
    .page-container-wrapper {
      .page-container {
        .footer-links {
          ul {
            width: 50%;
            margin-bottom: 32px;

            &:nth-child(3) {
              clear: left;
            }
          }
        }
      }
    }
  }
}

@media (max-width: 767px) {
  .footer {
    .page-container-wrapper {
      .page-container {
        padding-top: 24px;
        padding-bottom: 24px;

        .footer-links {
          padding-bottom: 20px;
        }
      }
    }
  }
}

@media (max-width: 479px) {
  .footer {
    .page-container-wrapper {
      .page-container {
        .footer-links {
          ul {
            width: 100%;
            float: none;
          }
        }

        .branding {
          display: block;

          .copyright {
            display: block;
          }

          .list {
            display: inline-block;
            width: 100%;
          }
        }
      }
    }
  }
}

